import React from 'react';
import { Route } from 'react-router-dom';

import DashBoard from './views/containers/DashBoard'

const SaccoBaseRouter = () =>(
    <div>
        <Route exact path='/' component={DashBoard}  />


    </div>
);

export default SaccoBaseRouter;


